import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, lang, placeholder, ...props }, ref) => {
  const resolvedLang = lang ?? (type === 'date' ? 'en-US' : undefined);
  const resolvedPlaceholder = placeholder ?? (type === 'date' ? 'MM/DD/YYYY' : undefined);
  return (
    <input
      type={type}
      lang={resolvedLang}
      placeholder={resolvedPlaceholder}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
